import { downloadCsv, locateCsvColumns, parseCsvRecords } from "./csvTools";

export const MAX_PARTICIPANTS = 10;
export const MIN_PARTICIPANTS = 4;
export const NAME_MIN = 3;
export const NAME_MAX = 20;
export const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const CSV_HEADERS = ["first_name", "last_name", "email_id"];

/** Same rows as old/admin/sample-participants.csv. */
const SAMPLE_CSV_ROWS = [["prachi", "mishra", "prachi@extramile.in"]];

export function downloadSampleParticipantsCsv() {
  downloadCsv(CSV_HEADERS, SAMPLE_CSV_ROWS, "sample-participants.csv");
}

/** old/admin/getcsv-admin-participants.php: SELECT first_name, last_name, email_id ... as CSV. */
export function exportParticipantsCsv(participants) {
  downloadCsv(
    CSV_HEADERS,
    participants.map((p) => [p.first_name, p.last_name, p.email_id]),
    "participants.csv"
  );
}

/** Returns "" when valid, otherwise the first user-facing error. */
export function validateParticipant({ first_name, last_name, email_id }) {
  for (const [label, value] of [["First name", first_name], ["Last name", last_name]]) {
    const v = String(value ?? "").trim();
    if (v.length < NAME_MIN || v.length > NAME_MAX) {
      return `${label} must be ${NAME_MIN} to ${NAME_MAX} characters.`;
    }
  }
  if (!EMAIL_RE.test(String(email_id ?? "").trim())) {
    return "Please enter a valid email address (e.g., user@example.com)";
  }
  return "";
}

/**
 * Parse an uploaded CSV into [{ first_name, last_name, email_id }], with the checks of
 * old/admin/insertCSV_participants.php (max 10 rows, no duplicate email IDs).
 */
export function parseParticipantsCsv(text) {
  const { index, rows } = locateCsvColumns(parseCsvRecords(text), CSV_HEADERS);
  if (rows.length > MAX_PARTICIPANTS) {
    throw new Error(`You can upload only ${MAX_PARTICIPANTS} participants`);
  }

  const parsed = rows.map((cells, i) => {
    const participant = {
      first_name: String(cells[index.first_name] ?? "").trim(),
      last_name: String(cells[index.last_name] ?? "").trim(),
      email_id: String(cells[index.email_id] ?? "").trim(),
    };
    const error = validateParticipant(participant);
    if (error) throw new Error(`Row ${i + 2}: ${error}`);
    return participant;
  });

  const seen = new Set();
  const duplicates = new Set();
  parsed.forEach(({ email_id }) => {
    const key = email_id.toLowerCase();
    if (seen.has(key)) duplicates.add(email_id);
    seen.add(key);
  });
  if (duplicates.size) {
    throw new Error(`Duplicate email IDs found in the CSV: ${[...duplicates].join(", ")}`);
  }
  return parsed;
}
